module.exports = __webpack_public_path__ + "media/images/pen-9123633c.svg";